<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="430"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 v-on="{ ...onTooltip, ...on }"
                 :color="iconColor"
                 @click.stop.prevent=""
          >
            <v-icon>{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span>Filtros personalizados</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        Filtros personalizados
      </v-card-title>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              dense
              :cotacoes="cotacoes"
              v-model="fornecedoresLocal"
              class="rounded-tag-small"
              path="/cotacoes/matriz/fornecedores"
              :disabled="!hasCotacao"
            />
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-cotacao-produto
              dense
              :cotacoes="cotacoes"
              v-model="cotacoesItensLocal"
              class="rounded-tag-small"
              path="/cotacoes/matriz/produtos"
              :disabled="!hasCotacao"
            />
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Situação dos produtos"
              deletable-chips
              :items="situacoes"
              class="rounded-tag-small"
              v-model="situacoesLocal"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
            class="normal-btn-text rounded-tag-small elevation-0 mr-2 mb-1"
            @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import { mapGetters } from 'vuex';

export default {
  props: {
    cotacoes: Array,
  },
  data: () => ({
    menuOpened: false,
    fornecedoresLocal: null,
    cotacoesItensLocal: null,
    situacoesLocal: [],
  }),
  computed: {
    ...mapGetters('matriz', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    icon() {
      return this.hasCustomFilters ? 'mdi-filter' : 'mdi-filter-outline';
    },
    hasCotacao() {
      return this.cotacoes && this.cotacoes.length;
    },
    situacoes() {
      return [
        SituacaoCotacao.keys.ABERTA,
        SituacaoCotacao.keys.CARRINHO,
        SituacaoCotacao.keys.APROVACAO,
        SituacaoCotacao.keys.COMPRA,
        SituacaoCotacao.keys.FINALIZADA,
        SituacaoCotacao.keys.CANCELADA,
      ];
    },
    fornecedores: {
      get() {
        return this.$store.getters['matriz/fornecedores'];
      },
      set(fornecedores) {
        this.$store.dispatch('matriz/fornecedores', fornecedores);
      },
    },
    cotacoesItens: {
      get() {
        return this.$store.getters['matriz/cotacoesItens'];
      },
      set(cotacoesItens) {
        this.$store.dispatch('matriz/cotacoesItens', cotacoesItens);
      },
    },
    situacao: {
      get() {
        return this.$store.getters['matriz/situacao'];
      },
      set(situacao) {
        this.$store.dispatch('matriz/situacao', situacao);
      },
    },
  },
  methods: {
    emitChange() {
      this.fornecedores = this.fornecedoresLocal ? [...this.fornecedoresLocal] : null;
      this.cotacoesItens = this.cotacoesItensLocal ? [...this.cotacoesItensLocal] : null;
      this.situacao = this.situacoesLocal ? [...this.situacoesLocal] : [];
      this.$emit('change');
      this.close();
    },
    close() {
      this.menuOpened = false;
    },
    clearFilters() {
      this.situacoesLocal = [];
      this.fornecedoresLocal = null;
      this.cotacoesItensLocal = null;
      this.emitChange();
    },
  },
};
</script>
